/**
 * @generated SignedSource<<18d2a24df5c4448238a507853ee29870>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSwatchSelector_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly " $fragmentType": "PdpRespSwatchSelector_user";
};
export type PdpRespSwatchSelector_user$key = {
  readonly " $data"?: PdpRespSwatchSelector_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSwatchSelector_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSwatchSelector_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "0f1bcdc92d1d6e0fd182d5f7f33b5845";

export default node;
